import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.css';

const Legend = props => {
  const { data, onClick, onKeyPress, vertical, shape, size } = props;
  return (
    <div className={cn('legend', { vertical })}>
      {data.map(ele => (
        <div
          role="button"
          tabIndex={0}
          onClick={onClick}
          onKeyPress={onKeyPress}
          className={cn('row', shape)}
          key={ele.label}>
          <div
            className={cn('dot', shape)}
            style={{
              backgroundColor: ele.color,
              width: ele.size || size,
              height: ele.size || size
            }}
          />
          {ele.label && <div className="text">{ele.label}</div>}
          {ele.value && <div className="text">{ele.value}</div>}
        </div>
      ))}
      <style jsx>{styles}</style>
    </div>
  );
};

Legend.defaultProps = {
  vertical: false,
  data: [],
  onClick: () => {},
  onKeyPress: () => {},
  shape: 'dot',
  size: 10
};

Legend.propTypes = {
  /**
   * Data elements to represent in the legend
   */
  data: PropTypes.arrayOf(PropTypes.object),
  /**
   * Orientation of the legend
   */
  vertical: PropTypes.bool,
  /**
   * Boolean for legend color shape
   */
  shape: PropTypes.string,
  /**
   * Size of shape
   */
  size: PropTypes.number,
  /**
   * Click event callback
   */
  onClick: PropTypes.func,
  /**
   * Key press callback
   */
  onKeyPress: PropTypes.func
};

export default Legend;
